import { useContext } from 'react'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useAdAccountGroupLink, { useRelations } from '@hooks/useAdAccountGroupLink'
import { generateUrls as generateClientUrls } from '@hooks/useClient'
import { generateUrls as generateUserUrls } from '@hooks/useUser'

import PageContext from '@contexts/pageContext'

import { confirmDelete } from '@functions/entity'
import generateRedirectUrl from '@functions/utils/generateRedirectUrl'

import { AdAccountGroupLinkModel, ClientModel, UserModel } from '@models/types'

const getEditUrl = (adAccountGroupLink: AdAccountGroupLinkModel, linkableEntity: ClientModel | UserModel) => {
  if (adAccountGroupLink.linkableType === 'Client') {
    const { editClientUrl } = generateClientUrls(linkableEntity)
    return editClientUrl
  }

  const { editUserUrl } =  generateUserUrls(linkableEntity)
  return editUserUrl
}

interface AdAccountGroupLinkListItemProps {
  adAccountGroupLink: AdAccountGroupLinkModel,
}

const AdAccountGroupLinkListItem = (props: AdAccountGroupLinkListItemProps) => {
  const { adAccountGroupLink } = props
  const { linkableId } = adAccountGroupLink

  const adAccountGroupLinkPayload = useAdAccountGroupLink(adAccountGroupLink)

  const { linkableEntity } = useRelations(adAccountGroupLink)
  const entity = linkableEntity as ClientModel | UserModel
  const { name } = entity

  const editUrl = getEditUrl(adAccountGroupLink, entity)

  const {
    callbacks: {
      deleteAdAccountGroupLink: deleteFn,
    },
  } = adAccountGroupLinkPayload

  const pageContext = useContext(PageContext)
  const { callbacks } = pageContext
  const { deleteAdAccountGroupLink } = callbacks || {}

  const confirmDeletePayload = {
    callbacks: {
      deleteEntity: deleteAdAccountGroupLink,
      deleteFn,
    },
    strings: {
      deleteString: 'Unlink',
      entityName: 'Organisation',
      toastString: 'Unlinked',
    },
  }

  return (
    <DashboardModuleListItem title={name || `#${linkableId}`}>
      <DashboardModuleListItem.Actions>
        <DashboardModuleListItem.Icon
          onClick={() => confirmDelete(confirmDeletePayload)}
          type="delete"
        />

        <DashboardModuleListItem.Icon
          boxProps={{ marginLeft: 'medium' }}
          href={`${editUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default AdAccountGroupLinkListItem
